import styled from 'styled-components';
import { Text } from '@/components/Typography';

interface FeatureStateTagTextProps {
	language: string;
}

const LANGUAGE_STYLES = {
	'pt-BR': {
		fontSize: '0.55rem'
	},
	'en-US': {
		fontSize: '0.625rem'
	},
	'es-419': {
		fontSize: '0.55rem'
	},
	'es-ES': {
		fontSize: '0.55rem'
	},
	'es-MX': {
		fontSize: '0.55rem'
	},
	'es-AR': {
		fontSize: '0.55rem'
	},
	'es-CL': {
		fontSize: '0.55rem'
	},
	'es-CO': {
		fontSize: '0.55rem'
	},
	'es-PE': {
		fontSize: '0.5rem'
	},
	de: { fontSize: '0.625rem' },
	'de-DE': { fontSize: '0.625rem' },
	'de-AT': { fontSize: '0.625rem' },
	'de-CH': { fontSize: '0.625rem' },
	'de-LI': { fontSize: '0.625rem' },
	'de-LU': { fontSize: '0.625rem' },
	zh: { fontSize: '0.5rem' },
	'zh-CN': { fontSize: '0.625rem' },
	'zh-SG': { fontSize: '0.625rem' },
	'zh-Hans': { fontSize: '0.625rem' },
	'zh-Hans-CN': { fontSize: '0.625rem' },
	'zh-Hans-SG': { fontSize: '0.625rem' }
} as const;

type Language = keyof typeof LANGUAGE_STYLES;

export const FeatureStateTagContainer = styled.div`
	background-color: #5474d1;
	width: fit-content;
	height: 1rem;
	gap: 0.5rem;
	padding-top: 0.125rem;
	padding-bottom: 0.125rem;
	padding-left: 0.25rem;
	padding-right: 0.25rem;
	border-radius: 0.125rem;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const FeatureStateTagText = styled(Text)<FeatureStateTagTextProps>`
	color: #f7f8fd;
	font-size: ${({ language }) => LANGUAGE_STYLES[language as Language]?.fontSize || '0.625rem'};
	letter-spacing: 0%;
`;
